<template>
	<div class="title">
		<div class="title-container">
			<h1 class="title2">
				Votre enfant <nobr>respire-t-il</nobr> <br/> un air trop pollué&nbsp;?
	  		</h1>
  		</div>
	</div>
</template>

<script>


export default {
	name: 'TitleControl',
}
</script>


<style scoped lang="scss">
.title  {
	background-image: linear-gradient(to bottom, rgba(255,255,255,1) 0%,rgba(255,255,255,.7) 60%,rgba(255,255,255,.4) 80%,rgba(255,255,255,0) 100%);
	padding-top: 1rem;
	padding-bottom: 1rem;
	width: 100%;
}

.title-container {
	text-align: center;
	width: 100%;
	max-width: 320px;
	margin: 0 auto;

	&:not(:last-child) {
		margin-bottom: 1rem;
	}

	@include from($tablet) {
		max-width: 400px;
	}

	@include from($desktop) {
		max-width: 500px;
	}
}

.br {
	display: none;
	@include from($desktop) {
		display: block;
	}
}

.title2 {
	font-family: "Archivo", sans-serif;
	font-weight: 700;
	color: #1e2832;
	font-size: 30px;
	line-height: 1;

	@include from($tablet) {
		font-size: 40px;
	}
}
</style>
